export default function Header() {
  return (
    <div className="header">
      <img src={require("../Troll Face.png")} alt="" />
      <h2>Meme Generator</h2>
      <p>React Course - Project 3</p>
    </div>
  );
}
